<div class="auth-page-wrapper public-page recupera-password">
	<div class="login-wave-header">
		<h1>Recupera Password</h1>
	</div>

	<div class="form-page-wrapper" style="justify-content: normal;">
		<div class="mb-2">
			<h2 class="titolo mb-1">Password dimenticata?</h2>
			<p class="sottotitolo">Nessun problema, ti invieremo le istruzioni per reimpostare la password.</p>
		</div>

		<form (ngSubmit)="resetPassword()" #resetForm="ngForm">
			<div class="form-group">
				<label class="form-label-kf" for="username">Username</label>
				<input id="username" type="email" class="form-control-kf" placeholder="test@mail.com" [ngModel]="username()" (ngModelChange)="username.set($event)" name="username" required autocomplete="username" />
			</div>

			@if (success()) {
				<div class="d-flex align-items-start gap-2 p-3 mb-3 rounded-3" style="background:#E9F7EF;">
					<i class="bi bi-check-circle-fill icona-success"></i>
					<span class="testo-success">Email inviata! Controlla la tua casella di posta.</span>
				</div>
			}

			@if (error()) {
				<div class="d-flex align-items-start gap-2 p-2 mb-3 rounded-3 errore">
					<i class="bi bi-exclamation-circle-fill icona-errore"></i>
					<span class="testo-errore">{{ errorMessage() || 'Si è verificato un errore. Riprova.' }}</span>
				</div>
			}

			<button type="submit" class="btn-kf-primary" [disabled]="loading() || success()">
				@if (loading()) {
					<span class="spinner-border spinner-border-sm me-2"></span>
				}
				REIMPOSTA LA PASSWORD
			</button>
		</form>

		<div class="text-center mt-3">
			<button class="btn-kf-link" type="button" (click)="goToLogin()">
				<i class="bi bi-arrow-left"></i>
				Torna alla Login
			</button>
		</div>
	</div>

	<div class="login-wave-footer"></div>
</div>
